module.exports = __webpack_public_path__ + "static/media/md-battery-full.da14b321.svg";